import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'

export const PROMPT_SCROLL_HEIGHT_THRESHOLD = 40

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 6px;
`

export const PromptText = styled.div<{
  $isExpanded: boolean
  $scrollHeight?: number
  $isExpandable: boolean
}>`
  height: ${({ $isExpanded, $scrollHeight }) =>
    $isExpanded ? `${$scrollHeight}px` : `${PROMPT_SCROLL_HEIGHT_THRESHOLD}px`};
  max-width: calc(100% - 28px);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ $isExpanded }) => ($isExpanded ? 'unset' : '2')};
  overflow: hidden;
  overflow-wrap: anywhere;
  color: ${COLORS.secondarySemiDark};
  cursor: pointer;

  ${({ $isExpandable }) =>
    !$isExpandable &&
    css`
      max-height: max-content;
    `}

  transition: height 0.3s ease-in-out;
`

export const CopyButton = styled.button`
  cursor: pointer;
  margin-top: 2px;
  background: none;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    &:hover * {
      fill: ${COLORS.secondarySemiDark};
    }
    &:active * {
      fill: ${COLORS.secondaryDark};
    }
  }
`
